// 2026 F1 Calendar — official schedule from formula1.com
const f1Calendar2026 = [
  { round: 1, name: "Australian Grand Prix", location: "Melbourne", date: "2026-03-08" },
  { round: 2, name: "Chinese Grand Prix", location: "Shanghai", date: "2026-03-15" },
  { round: 3, name: "Japanese Grand Prix", location: "Suzuka", date: "2026-03-29" },
  { round: 4, name: "Bahrain Grand Prix", location: "Sakhir", date: "2026-04-12" },
  { round: 5, name: "Saudi Arabian Grand Prix", location: "Jeddah", date: "2026-04-19" },
  { round: 6, name: "Miami Grand Prix", location: "Miami", date: "2026-05-03" },
  { round: 7, name: "Canadian Grand Prix", location: "Montreal", date: "2026-05-24" },
  { round: 8, name: "Monaco Grand Prix", location: "Monte Carlo", date: "2026-06-07" },
  { round: 9, name: "Spanish Grand Prix", location: "Barcelona", date: "2026-06-14" },
  { round: 10, name: "Austrian Grand Prix", location: "Spielberg", date: "2026-06-28" },
  { round: 11, name: "British Grand Prix", location: "Silverstone", date: "2026-07-05" },
  { round: 12, name: "Belgian Grand Prix", location: "Spa", date: "2026-07-19" },
  { round: 13, name: "Hungarian Grand Prix", location: "Budapest", date: "2026-07-26" },
  { round: 14, name: "Dutch Grand Prix", location: "Zandvoort", date: "2026-08-23" },
  { round: 15, name: "Italian Grand Prix", location: "Monza", date: "2026-09-06" },
  { round: 16, name: "Madrid Grand Prix", location: "Madrid", date: "2026-09-13" },
  { round: 17, name: "Azerbaijan Grand Prix", location: "Baku", date: "2026-09-26" },
  { round: 18, name: "Singapore Grand Prix", location: "Marina Bay", date: "2026-10-11" },
  { round: 19, name: "United States Grand Prix", location: "Austin", date: "2026-10-25" },
  { round: 20, name: "Mexico City Grand Prix", location: "Mexico City", date: "2026-11-01" },
  { round: 21, name: "Brazilian Grand Prix", location: "Sao Paulo", date: "2026-11-08" },
  { round: 22, name: "Las Vegas Grand Prix", location: "Las Vegas", date: "2026-11-21" },
  { round: 23, name: "Qatar Grand Prix", location: "Lusail", date: "2026-11-29" },
  { round: 24, name: "Abu Dhabi Grand Prix", location: "Yas Marina", date: "2026-12-06" },
];

export const getNextRace = () => {
  const now = new Date();
  return f1Calendar2026.find((race) => new Date(race.date) > now) || null;
};

export const getDaysUntil = (dateStr) => {
  const now = new Date();
  const target = new Date(dateStr);
  const diff = target - now;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export default f1Calendar2026;
